import "bootstrap/dist/css/bootstrap.min.css";
// import "primereact/resources/themes/saga-green/theme.css";
import "./styles/project-theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import '@fortawesome/fontawesome-free/css/all.css';

import "./styles/bootstrap-common.css";
import "./styles/header-common.css";
import "./styles/pda-theme-common.css";
import "./styles/styles.css";
import "./styles/styles-common.css";
import "./styles/tasks-common.css";
import "./styles/tree-common.css";
import "./styles/tokens.css";
import "./styles/projectdocs-list.css";
import "./styles/projectdocs-edit.css";
import "./styles/reports.css";

import React from 'react';
import { createRoot } from 'react-dom/client';
import { PrimeReactProvider } from 'primereact/api';
import { App } from './App';
import { createBrowserHistory } from 'history';
import configureStore from './store/configureStore';
import { connectServices } from './services';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router';
import environment from './helpers/environment';
import { KeycloakProvider } from './contexts/KeycloakContext';
import keycloak from './config/keycloak';

if (environment.websiteName) {
  document.title = environment.websiteName;
}

const baseUrl = environment.baseUrl.replace(/\/$/, '') || '/';
const history = createBrowserHistory({ basename: baseUrl });
const store = configureStore(history);
connectServices(history);

const root = createRoot(document.getElementById('root')!);

const primeReactSettings = {
  locale: 'ru',
  ripple: true,
};

root.render(
  <Provider store={store}>
    <Router basename={baseUrl}>
      <React.Fragment>
        <KeycloakProvider keycloak={keycloak}>
          <PrimeReactProvider value={primeReactSettings}>
            <App />
          </PrimeReactProvider>
        </KeycloakProvider>
      </React.Fragment>
    </Router>
  </Provider>
);
